module.exports = __webpack_public_path__ + "static/media/64b-nursery.f0f33dfe.jpg";